import { EnvironmentId } from 'api/apiTypes';
import routes from 'api/routes';
import useSWR from 'swr';

import { useAxios } from 'utils/transport/useAxios';

import { ScheduledExportSchema } from '../types';

/**
 * GET /dataexport/schedule/:scheduleId - Get schedule details (JWT auth)
 */
export function useScheduledExport(scheduleId: string | null) {
  const { get } = useAxios();

  return useSWR(
    scheduleId ? routes.dataExport.getSchedule(scheduleId) : null,
    async (url) => {
      const response = await get(url, { withCredentials: true });
      const data = ScheduledExportSchema.parse(response.data);
      return data ?? null;
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
}

/**
 * GET /dataexport/schedules/:envGuid - List schedules (JWT auth)
 */
export function useScheduledExports(envGuid: EnvironmentId | null) {
  const { get } = useAxios();

  return useSWR(
    envGuid ? routes.dataExport.listSchedules(envGuid) : null,
    async (url) => {
      const response = await get(url, { withCredentials: true });
      const data = ScheduledExportSchema.array().parse(response.data);
      return data;
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
}
